module.exports = __webpack_public_path__ + "img/wks.37ee9e8f.svg";